import React from 'react';
import LeftNav from '../common/leftnav/leftnav';
import HeaderTop from '../common/headerTop/headerTop';
import CommonMessage from '../common/commonMessage';
import $ from 'jquery';
import { VolumeService } from './../../services/volume.service';
import { RegionService } from './../../services/region.service';
import { ServerService } from './../../services/server.service';
import VolumeBackup from './VolumeBackup';
import ReactToolTip from 'react-tooltip';
import { isPositiveNonZero } from '../../utility/utility';
import { AuditLog } from './../../services/auditlog.service';
import './../server/Region.css';
import Axios from 'axios';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../../constants/server.constant';
import { ResourceService } from './../../services/resource.service';
import { Redirect } from 'react-router-dom';
import { getMessage } from '../../constants/messagesMapper';
import ScrollArea from 'react-scrollbar';
import NotificationSlider from '../common/topRightHeader/notificationSlider';
import { FlavorService } from './../../services/flavor.service';
import { loginService } from '../../services/login.service';
class VolumesMain extends React.Component {

    constructor(props) {
        super(props);
        //loadcss();

        this.state = {
            allInstanceList: [],
            loading: true,
            message: '',
            regionList: [],
            computeRegionList: [],
            instanceList: [],
            selectedRegionUrl: '',
            selectedVolume: {},
            volumeList: [],
            renameName: '',
            extendVolume: '',
            isAction: false,
            showConfig: false,
            errorMessg: '',
            messgType: '',
            selectedRegion: '',
            isTabActive: true,
            backupName: '',
            size: '10',
            nameToggle: false,
            dateToggle: true,
            attachedToggle: false,
            sizeToggle: false,
            regionToggle: false,
            statusToggle: false,
            columnType: 'date',
            volumeName: '',
            selectedInstanceId: '',
            selectedInstanceName: '',
            nameErrorMessg: '',
            sizeErrorMessg: '',
            regionListFilter: [],
            regions: [],
            countryName: '',
            isregionselected: false,
            selectedDropDown: '',
            isCreateAction: false,
            isUserSubscribed: false,
            isRedirectToCCPage: false,
            dropRegion: '',
            logInstanceDetachName: "",
            isApiTriggered: false,
            regionMaintList: [],
            isRegionStatus: false,
            regionCount: 0,
            regionString: "",
            isCluster: "",
            indexCount: 0,
            count: 50,
            volumesPaged: [],
            isYearly: true,
            discId: "",
            discCode: "",
            discPerce: "",
            discVal: "",
            volPrice: 0.1,
            openAmountPopUp: false,
            amount: 0.0,
            delVolName: "",
            isCreateExternalDisabled: !loginService.isInternalUser()
        };
        this.getInstanceName = this.getInstanceName.bind(this);
        this.volSnapRef = React.createRef();
        this.scrollRef = React.createRef();
        this.checkForSubscription = this.checkForSubscription.bind(this);
        this.escfunction = this.escfunction.bind(this);
    };

    componentDidMount() {
        document.addEventListener("keyup", this.escfunction, false);
        this.setState({
            isAction: true
        });
        this.setDiscount();
        this.checkForSubscription();
    }
    escfunction(event) {
        if(event.keyCode === 27) {
            this.setState({
                openAmountPopUp: false
            });
            $("body").removeClass("popup_no_scroll");

        }
    }
    setDiscount() {
        FlavorService.getDiscounts().then(resp => {
            if(Array.isArray(resp)) {

                for(let i = 0; i < resp.length; i++) {
                    if(resp[i].code_type == "cloud") {
                        let ob = resp[i];
                        this.setState({ discId: ob.id, discCode: ob.code, discPerce: ob.discount, discVal: 100 / ob.discount });
                    }

                }

            }
        });
    }
    checkForSubscription = () => {
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({ isAction: false, message: "Error while getting user subscription details" });
                return;
            }
            if(resp.error) {
                this.setState({
                    isAction: false,
                    isUserSubscribed: true
                });
                this.loadRegions();
            }
            else {
                this.setState({
                    isUserSubscribed: false
                });
                this.loadRegions();
                this.setRegionList();
                this.setAllInstanceList();
                this.setComputeRegionList();

                this.getMaintananceRegions();
                var cluster = localStorage.getItem("clusterMessage");
                if(cluster !== null && cluster !== undefined) {
                    this.setState({
                        isCluster: localStorage.getItem("clusterMessage")
                    });
                }
                else {
                    localStorage.setItem("clusterMessage", "show");
                    this.setState({
                        isCluster: "show"
                    });
                }
            }

        });
    };
    getMaintananceRegions = () => {
        let userId = localStorage.getItem("userId");
        axiosInstance.get(API_HOST + "/regions/maintainance/" + userId, axiosRequestWithAuth).
            then(resp => {

                let res = resp.data;
                let string = "";
                this.setState({
                    regionCount: res.length,
                    regionMaintList: res
                });
                if(res.length > 0) {
                    for(let i = 0; i < res.length; i++) {
                        string += res[i].name + " (" + res[i].region_id + ")" + ", ";
                    }
                    this.setState({
                        isRegionStatus: true,
                        regionString: string.replace(/,\s*$/, "")
                    });
                }

            })
            .catch(error => {
                console.log(error);
            });
    };

    setRegionList() {
        RegionService.getByProject('volumev3').then(resp => {
            if(resp && resp.length > 0) {
                this.setState({ regionList: resp });
            }
        }).catch(error => {

        });
    };
    loadRegions = () => {
        RegionService.getAll().then((resp) => {
            if(resp === false) {
                this.setState({ regionListFilter: [] });
            }
            resp = resp.filter(item => !this.isBlackListVolRegion(item));
            this.setState({ regions: resp });
        });

    };

    setAllVolumes(type, isCreate, respVol = []) {
        this.setState({ isAction: true });
        let checkVolume = "";
        if(this.state.isUserSubscribed) {
            checkVolume = this.state.regionName;
        }
        else {
            checkVolume = this.state.selectedInstanceId;
        }
        VolumeService.getAll().then(resp => {
            if(isCreate === undefined) {
                this.setState({ isAction: false });
            }
            if(resp && resp.length > 0) {
                let creatingItems = resp.filter(item => item.status === 'creating' || item.status === 'reserved');
                if(this.state.volumeList && this.state.isApiTriggered) {
                    let errorItems = this.state.volumeList.filter(item => item.status === 'error');
                    let errorRespItems = resp.filter(elem => elem.status === 'error');
                    if(errorItems.length < errorRespItems.length) {
                        this.setState({ isApiTriggered: false, messgType: 'error', message: "Volume moved to error state, Please try after sometime" });
                    }
                }
                if(creatingItems.length > 0) {
                    this.invokeSeperatePolling(creatingItems);
                }
                let volumeList = this.getSortableData(type, resp);
                let volumesPaged = volumeList.slice(0, this.state.count);
                this.setState({ volumesPaged: volumesPaged, volumeList: volumeList, indexCount: 0 },
                    () => {
                        this.activateActionMenu1();
                        if(resp.length > 0) {
                            if(checkVolume !== undefined && checkVolume !== '') {
                                this.attachVolumetoInstance(respVol);
                            } else {
                                this.setState({ isAction: false });
                            }
                        }

                    });
            }
        });
    }

    invokeSeperatePolling(creatList) {
        let geturl = window.location.href;
        if(geturl.indexOf("volumes") === -1) {
            return;
        }
        if(creatList !== undefined && creatList.length > 0) {
            creatList.forEach(elem => {
                this.setVolumeStatus(elem.id, elem.region);
            });
        }
    }

    setVolumeStatus(volumeId, region) {
        VolumeService.getVolumeById(volumeId, region).then(resp => {
            if(resp !== null && resp !== undefined && resp.volume && resp.volume.status) {
                let volumeElem = resp.volume;
                if(volumeElem.status !== 'creating') {
                    let backupList = this.state.volumeList;
                    let index = backupList.findIndex(item => item.id === volumeId);
                    let elem = backupList[index];
                    elem.status = volumeElem.status;
                    backupList[index] = elem;
                    this.setState({ volumeList: backupList });
                    return;
                } else if(volumeElem.status === 'creating') {
                    let time = volumeElem.size > 5 ? volumeElem.size * 2000 : 5000;
                    sessionStorage.volumeInterval = setTimeout(() => this.setVolumeStatus(volumeId, region), time);
                }
            }
        });
    }


    setComputeRegionList() {
        RegionService.getRegionListByType('compute').then(resp => {
            if(resp && resp.length > 0) {
                this.setState({ computeRegionList: resp });
            }
        });
    }

    getComputeRegionUrl(regionName) {
        let computeRegionList = this.state.computeRegionList;
        return computeRegionList.find(item => item.region === regionName).url;
    }

    getVolumeRegionUrl(regionName) {

        let volumeRegionList = this.state.regionList;

        let volume = volumeRegionList.find(item => item.region === regionName);
        if(volume == undefined)
            return;
        return volume.url;
    }
    checkBM(id) {
        let bmList = JSON.parse(localStorage.getItem("BMflavors"));
        for(let i = 0; i < bmList?.length; i++) {
            if(id == bmList[i].id) {
                return false;
            }
        }
        return true;
    }
    setAllInstanceList() {
        this.setState({ isAction: true });
        ServerService.getServerList(false).then(resp => {

            if(resp) {
                let flavorList = [];
                for(let i = 0; i < resp.length; i++) {
                    if(this.checkBM(resp[i].flavor.id)) {
                        flavorList.push(resp[i]);
                    }
                }
                this.setState({ allInstanceList: flavorList }, () => this.setAllVolumes('date'));
                return;
            }
            this.setState({ isAction: false, message: resp.message, messgType: 'warning' });
        });
    }

    getInstanceName(volume) {
        let attachments = volume.attachments;
        volume.instanceName = 'None';
        if(attachments === undefined || attachments.length === 0) {
            return 'None';
        }
        let instanceId = attachments[0].server_id;
        let instance = this.state.allInstanceList.find(item => item.id === instanceId);
        if(instance === undefined) {
            return 'None';
        }
        volume.instanceName = instance.name;
        return instance.name;
    }

    onRowMenuClick = (event, volume) => {

        this.setState({ selectedVolume: volume, selectedRegionUrl: this.getRegionUrl(volume.region), logInstanceDetachName: volume.instanceName });

        $(event.currentTarget).closest('.tr').find('.dropdown_component ').toggleClass('active');

    };
    activateActionMenu1() {
        var documentwindowHeight = $(document).height();
        $('.dashboard_module .table_data .tr .row_menu_icon, .tabular_data_wrap li .menu_icon').click(function () {

            $('.tabular_data_wrap .table_data .tr').removeClass('row_selected');
            $(this).closest('.tr').addClass('row_selected');
            //$(this).closest('.dashboard_module .tr').find('.dropdown_component').toggleClass('row_selected');
            $(this).find('.dropdown_component').css({ top: '30px' });
            let fmi = 'dropdown_component';
            var offset = $(this).offset();
            var x = (offset.left);
            var y = (offset.top);
            var windowHeight = $(window).height();
            var menuHeight = $(this).find('.' + fmi).height();
            var totalHeight = menuHeight + y;
            // alert("totHeight:" + totalHeight);
            // alert("docwindowHeight:" + documentwindowHeight);
            if((windowHeight <= 800) && (menuHeight <= 200)) {
                totalHeight = totalHeight + 50;
            }
            if(documentwindowHeight < totalHeight) {
                $('.' + fmi).css({ top: -Math.abs(menuHeight + 10) });
                $('.arrow_pointer').addClass('bottom_arrow');

                if(windowHeight < 800) {
                    //alert('test 1' + windowHeight)
                    totalHeight = totalHeight - windowHeight;
                    totalHeight = totalHeight - $(this).find('.dropdown_component').innerHeight();
                    totalHeight = totalHeight + 50;
                    //alert('1 condition'+totalHeight);
                    window.scrollTo({ top: totalHeight, behavior: 'smooth', });
                    $(this).find('.dropdown_component').css({ zIndex: '999' });
                }
            }
            else if(documentwindowHeight > totalHeight) { //alert('test 2')
                totalHeight = totalHeight - windowHeight;
                totalHeight = totalHeight + 50;
                $('.arrow_pointer').removeClass('bottom_arrow');

                window.scrollTo({ top: totalHeight, behavior: 'smooth', });
            }

        });
    }

    showConfiguration = (event) => {
        this.setState({ showConfig: true });
    };

    onAddVolumeClick = () => {
        $('.createVolume_slider').addClass('active');

        let regionList = this.state.regionList;
        let instanceList = this.state.allInstanceList.filter(item => item.status !== 'ERROR' && !this.isBlackListInstRegion(item));

        // setTimeout(() => {
        //     document.getElementById('volumeName').focus();
        // }, 400);
        this.setState({
            isregionselected: false,
            selectedRegionUrl: '',
            selectedInstanceId: '',
            selectedInstanceName: '',
            selectedRegion: '',
            errorMessg: '',
            nameErrorMessg: '',
            sizeErrorMessg: '',
            regionErrorMessg: '',
            volumeName: '',
            size: '',
            regionName: '', instanceList: instanceList, selectedDropDown: '', dropRegion: ''
        });
        $(".regionSelect_options").removeClass("active");
        $("body").addClass("popup_no_scroll");
        $(".volumes_main_module .main_slider .slider_wrapper").scrollTop(0);
        setTimeout(() => {
            document.getElementById('volumeName').focus();
        }, 500);


    };

    isBlackListInstRegion(item) {
        if(item.region === 'SFO1' || item.region === 'PX1' || item.region === 'ORD1' || item.region === 'MIA1') return true;
    }

    isBlackListVolRegion(item) {
        if(item.id === 'SFO1' || item.id === 'PX1' || item.id === 'ORD1' || item.id === 'MIA1') return true;
    }

    formHandler = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        // if (name === 'region') {
        //     this.setState({ selectedRegionUrl: this.getVolumeRegionUrl(val), selectedRegion: val, errorMessg: '' });
        //     return;
        // }
        if(name === 'instance') {
            if(val !== '') {
                let server = this.state.instanceList.find(item => item.id === val);
                this.setState({ selectedInstanceId: val, selectedInstanceName: server.name });
                return;
            }
        }

        if(name === 'allInstance') {
            if(val !== '') {
                let server = this.state.allInstanceList.find(item => item.id === val);
                let instanceList = this.state.allInstanceList.filter(item => item.region === server.region);
                let regionOb = this.state.regions.find(item => item.id === server.region);

                this.setState({
                    selectedInstanceId: val, selectedInstanceName: server.name, errorMessg: '', serverRegion: server.region, selectedRegion: regionOb.name, regionName: regionOb.id,
                    countryName: regionOb.countryName, selectedRegionUrl: this.getVolumeRegionUrl(regionOb.id), errorMessg: '', isregionselected: true, selectedDropDown: regionOb.id,
                    instanceList: instanceList, regionErrorMessg: ''
                });
                return;
            }
        }

        if(name === 'size' || name === 'extendVolume') {
            if(val !== '' && !isPositiveNonZero(val)) {
                return;
            }
            if(val > 1000) {
                return;
            }
        }
        if((name === 'volumeName' || name === 'renameName') && val.length > 20) {

            return;
        }
        this.setState({ [name]: val, errorMessg: '', nameErrorMessg: '', sizeErrorMessg: '' });
    };

    retryCreation() {
        let volName = this.state.selectedVolume.name.trim();
        this.setState({ isAction: true, errorMessg: '', isCreateAction: true });
        let requestBody = {
            volume: {
                size: this.state.selectedVolume.size,
                name: volName
            }
        };

        VolumeService.createVolume(requestBody, this.state.selectedVolume.region, false).then(resp => {
            if(resp && resp.volume) {
                this.setState({
                    message: "Volume created successfully", isCreateAction: false,
                    volumeName: '', size: '10', messgType: 'success', isApiTriggered: true
                });
                this.setAllVolumes(this.state.columnType, true);
                const volumeBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Volume " + requestBody.volume.name + " has been created",
                    "operation": "Volume Creation",
                    "region": this.state.selectedDropDown
                };
                AuditLog.storeAuditLogs(volumeBody, "instance").then((resp) => {
                    if(resp === false);
                });

                this.setState({ isAction: false });
                return;
            }
            this.setState({ isAction: false, message: "failure", messgType: 'error', isCreateAction: false });
        });
    }

    createVolume() {
        let volName = this.state.volumeName.trim();
        let checkVolume = "";
        if(this.state.isUserSubscribed) {
            checkVolume = this.state.regionName;
        }
        else {
            checkVolume = this.state.selectedInstanceId;
        }
        // if (this.state.instanceList.length > 0 && (checkVolume === undefined || checkVolume === '')) {
        //     this.setState({ errorMessg: 'Select the instance to attach to new volume' });
        //     return;
        // } 
        if(!this.state.isregionselected) {
            this.setState({ regionErrorMessg: 'Select the region to create new volume' });
            return;
        } else if(volName === undefined || volName === '') {
            this.setState({ nameErrorMessg: 'Volume name is mandatory to create new volume' });
            document.getElementById('volumeName').focus();
            return;
        } else if(this.state.size === undefined || this.state.size === '') {
            this.setState({ sizeErrorMessg: 'Volume size is mandatory to create new volume' });
            document.getElementById('size').focus();
            return;
        }
        // else if(this.isNameExist(volName,this.state.selectedDropDown)) {
        //     this.setState({ nameErrorMessg: 'Volume name should not be duplicate' });
        //     document.getElementById('volumeName').focus();
        //     return;
        // }
        else if(this.state.size > 1000) {
            this.setState({ sizeErrorMessg: 'Size should not be more than 1000 GB' });
            document.getElementById('size').focus();
            return;
        }
        // else if(this.state.size < 10) {
        //     this.setState({ sizeErrorMessg: 'Size should be more than 10 GB' });
        //     document.getElementById('size').focus();
        //     return;
        // }
        if(this.state.isUserSubscribed) {
            this.setState({
                isRedirectToCCPage: true
            });
        }
        else {
            if(this.state.isCreateAction) {
                return;
            }
            if(this.state.isYearly) {
                if(this.state.size < 10) {
                    this.setState({ sizeErrorMessg: 'Minimum volume size required: 10 GB' });
                    document.getElementById('size').focus();
                    return;
                }
            }
            this.setState({ isAction: true, errorMessg: '', isCreateAction: true });
            let requestBody = {
                volume: {
                    size: this.state.size,
                    name: volName
                }
            };

            let i18n = this.props.i18n;
            VolumeService.createVolume(requestBody, this.state.selectedDropDown, this.state.isYearly).then(resp => {
                if(resp === "PAYMENT_ERROR") {
                    this.setState({
                        message: "An error occurred while processing the card details.You can try again by adding another card or after sometime.",
                        error: true,
                        isAction: false,
                        isCreateAction: false
                    });
                    return;
                }
                if(resp && resp.volume) {

                    this.setState({
                        message: i18n.t('vol_create_success'), isCreateAction: false,
                        volumeName: '', size: '10', messgType: 'success', isApiTriggered: true, isYearly: true
                    });
                    this.setAllVolumes(this.state.columnType, true, resp.volume);
                    const volumeBody = {
                        "userId": localStorage.getItem("userId"),
                        "name": "Volume " + requestBody.volume.name + " has been created",
                        "operation": "Volume Creation",
                        "region": this.state.selectedDropDown
                    };
                    AuditLog.storeAuditLogs(volumeBody, "instance").then((resp) => {
                        if(resp === false);
                    });

                    $('.createVolume_slider').removeClass('active');
                    $("body").removeClass("popup_no_scroll");
                    return;
                }
                this.setState({ isAction: false, message: i18n.t('vol_create_failure'), messgType: 'error', isCreateAction: false });
            });
        }
    }

    attachVolumetoInstance(volume) {
        let selectedInstanceId = this.state.selectedInstanceId;
        let instanceList = this.state.instanceList;
        if(instanceList.length === 0) {
            this.setState({ errorMessg: 'No instance is available to attach' });
            return;
        }
        if(selectedInstanceId === undefined || this.state.selectedInstanceId === '') {
            this.setState({ errorMessg: 'Select the instance to attach to the volume' });
            return;
        }
        this.setState({ isAction: true });
        this.attachCancel();
        let compRegionUrl = '';
        let volumeId = '';
        let logRegion = '';
        if(volume === undefined) {
            compRegionUrl = this.getComputeRegionUrl(this.state.selectedVolume.region);
            volumeId = this.state.selectedVolume.id;
            logRegion = this.state.selectedVolume.region;
        } else {
            compRegionUrl = this.getComputeRegionUrl(this.state.serverRegion);
            volumeId = volume.id;
            logRegion = this.state.serverRegion;
        }
        let i18n = this.props.i18n;
        let logInstanceName = this.state.selectedInstanceName;
        let logVloumeName = this.state.selectedVolume.name;
        VolumeService.attachInstanceById(selectedInstanceId, volumeId,
            compRegionUrl, logRegion).then(resp => {
                if(resp && resp.volumeAttachment) {
                    const volumeBody = {
                        "userId": localStorage.getItem("userId"),
                        "name": "Volume " + logVloumeName + " has been attached to instance " + logInstanceName,
                        "operation": "Volume Attach",
                        "region": logRegion
                    };
                    AuditLog.storeAuditLogs(volumeBody, "instance").then((resp) => {
                        if(resp === false);
                    });

                    this.attachAttachment(volumeId, resp.volumeAttachment);
                    this.setState({ message: i18n.t('vol_attach_success'), messgType: 'success', isAction: false });
                    return;
                }
                if(resp && resp.conflictingRequest) {
                    this.setState({ isAction: false, message: getMessage(resp.conflictingRequest.message), messgType: 'warning' });
                    return;
                }


                if(resp && typeof resp === 'string') {
                    this.setState({ isAction: false, message: resp, messgType: 'error' });
                    return;
                }
                if(resp && resp.badRequest && resp.badRequest.message) {
                    this.setState({ isAction: false, message: getMessage(resp.badRequest.message), messgType: 'error' });
                    return;
                }
                this.setState({ isAction: false, message: i18n.t('vol_attach_failure'), messgType: 'error' });
            });
    }

    isNameExist = (name, regionName) => {
        let ob = this.state.volumeList.find(item => item.region === regionName && item.name === name.trim());
        if(ob !== undefined) {
            return true;
        }
        return false;
    };

    getRegionUrl(region) {
        return this.state.regionList.find(item => item.region === region).url;
    }

    onAttachClick() {
        let instances = this.state.allInstanceList.filter(item => item.region === this.state.selectedVolume.region && item.status !== 'ERROR');
        if(instances.length > 0) {
            this.setState({ selectedInstanceId: '', selectedInstanceName: '' });
        }
        this.setState({ instanceList: instances, errorMessg: '' });
        $('.attachVolume_slider').addClass('active');
    }

    deleteVolumeById() {
        let snapshots = [];
        this.setState({ isAction: true });
        $('.delete_volume_popup').removeClass('active');
        $("body").removeClass("popup_no_scroll");
        let selectedVolumeId = this.state.selectedVolume.id;
        if(sessionStorage.snapshotList !== undefined) {
            let snapshotList = JSON.parse(sessionStorage.snapshotList);
            snapshotList.forEach(element => {
                if(element.volume_id === selectedVolumeId) {
                    snapshots.push(element.id);
                }
            });

        }
        let i18n = this.props.i18n;
        VolumeService.deleteVolumeById(selectedVolumeId, snapshots, this.state.selectedRegionUrl, this.state.selectedVolume.region).then(resp => {
            if(resp === null) {
                //this.volSnapRef.current.setBackupList();
                let volumeList = this.state.volumeList;
                let index = volumeList.findIndex(item => item.id === selectedVolumeId);
                volumeList.splice(index, 1);
                let volumesPaged = [...volumeList];
                if(volumeList.length > this.state.count) volumesPaged = volumesPaged.splice(0, this.state.count);

                const volumeBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Volume " + this.state.selectedVolume.name + " has been deleted",
                    "operation": "Volume Deletion",
                    "region": this.state.selectedVolume.region
                };
                AuditLog.storeAuditLogs(volumeBody, "instance").then((resp) => {
                    if(resp === false);
                });
                this.setState({ message: i18n.t('vol_delete_success'), isAction: false, messgType: 'success', indexCount: 0, volumesPaged: volumesPaged });
                return;
            }
            if(resp && typeof resp === 'string') {
                this.setState({ isAction: false, message: resp, messgType: 'error' });
                return;
            }
            if(resp && resp.badRequest && resp.badRequest.message) {
                this.setState({ isAction: false, message: getMessage(resp.badRequest.message), messgType: 'error' });
                return;
            }
            this.setState({ isAction: false, message: i18n.t('vol_delete_failure'), messgType: 'error' });
        });
    }

    renameVolume() {
        let volName = this.state.renameName.trim();
        let oldVolumeName = this.state.selectedVolume.name;
        if(volName === undefined || volName === '' || volName === oldVolumeName) {
            this.setState({ errorMessg: 'Enter a new name for the volume' });
            return;
        }
        // else if(this.isNameExist(volName,this.state.selectedVolume.region)) {
        //     this.setState({ errorMessg: 'Volume name should not be duplicate' });
        //     return;
        // }
        let i18n = this.props.i18n;
        this.setState({ isAction: true, errorMessg: '' });
        let requestBody = {
            volume: {
                name: volName
            }
        };

        VolumeService.updateVolumeById(this.state.selectedVolume.id, requestBody, this.state.selectedRegionUrl, this.state.selectedVolume.region).then(resp => {
            if(resp && resp.volume) {
                let volume = resp.volume;
                let volumeList = this.state.volumeList;
                let volumesPaged = this.state.volumesPaged;
                let indexPaged = volumesPaged.findIndex(item => item.id === volume.id);
                let index = volumeList.findIndex(item => item.id === volume.id);
                volume.region = this.state.selectedVolume.region;
                volume.fullRegion = volumeList[index].fullRegion;
                volume.created_at = volumeList[index].created_at;
                volumeList[index] = volume;
                volumesPaged[indexPaged] = volume;

                const volumeBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Volume rename from " + oldVolumeName + " to " + requestBody.volume.name,
                    "operation": "Volume Rename",
                    "region": this.state.selectedVolume.region
                };
                AuditLog.storeAuditLogs(volumeBody, "instance").then((resp) => {
                    if(resp === false);
                });
                this.setState({ message: i18n.t('vol_rename_success'), isAction: false, selectedVolume: volume, volumeList: this.getSortableData(this.state.columnType, volumeList), messgType: 'success', volumesPaged: volumesPaged });
                this.renameCancel();
                return;
            }
            if(resp && typeof resp === 'string') {
                this.setState({ isAction: false, message: resp, messgType: 'error' });
                return;
            }
            this.setState({ isAction: false, message: i18n.t('vol_rename_failure'), messgType: 'error' });
        });
    }

    openConfirmPopUp = (Volamount, name) => {
        $("body").addClass("popup_no_scroll");
        this.setState({
            openAmountPopUp: true,
            amount: Volamount,
            delVolName: name
        });
    };
    extendVolumeSize(param) {
        let selectedVolume = this.state.selectedVolume;
        let extendVolume = this.state.extendVolume;
        if(param === "before") {
            if(extendVolume === undefined || extendVolume === '') {
                this.setState({ errorMessg: 'Provide the size to extend the volume' });
                return;
            } else if(extendVolume <= selectedVolume.size) {
                this.setState({ errorMessg: 'New size for extend must be greater than current size of ' + selectedVolume.size + ' GB' });
                return;
            } else if(this.state.extendVolume > 1000) {
                this.setState({ errorMessg: 'Volume size should not be more than 1000 GB' });
                return;
            }
        }
        if(param === "after") {
            this.setState({
                openAmountPopUp: false
            });
            $("body").removeClass("popup_no_scroll");
        }

        this.setState({ isAction: true, errorMessg: '' });
        this.extendCancel();
        let i18n = this.props.i18n;
        let requestBody = {
            "os-extend": {
                "new_size": parseInt(extendVolume)
            }
        };
        let oldVolumeSize = this.state.selectedVolume.size;
        let minVol = parseInt(oldVolumeSize) + 10;
        VolumeService.doVolumeActionById(selectedVolume.id, requestBody, this.state.selectedRegionUrl, this.state.selectedVolume.region, param).then(resp => {
            if(resp != null && resp.hasOwnProperty("confirm")) {

                this.setState({
                    isAction: false,
                });
                let amount = resp.amount;
                this.openConfirmPopUp(amount, selectedVolume.name);
                return;
            }
            if(resp === "VOL_STATUS_ERROR") {
                this.setState({
                    isAction: false,
                    message: "Volume cannot be extended, please try after sometime",
                    msgType: "error"
                });
                return;
            }
            if(resp === "SIZE_ERROR") {
                this.setState({
                    isAction: false,
                    message: "Minimum permissible size for extending yearly volume is 10 GB",
                    msgType: "success"
                });
                return;
            }
            if(resp === "PAYMENT_ERROR") {

                this.setState({
                    message: "An error occurred while processing the card details.You can try again by adding another card or after sometime.",
                    error: true,
                    isAction: false
                });
                return;

            }
            if(resp === null) {
                let volume = selectedVolume;
                volume.size = parseInt(extendVolume);
                let volumeList = this.state.volumeList;
                let index = volumeList.findIndex(item => item.id === volume.id);
                volumeList[index] = volume;
                const volumeBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": this.state.selectedVolume.name + " extended from " + parseInt(oldVolumeSize) + "GB to " + parseInt(extendVolume) + "GB",
                    "operation": "Volume Extend",
                    "region": this.state.selectedVolume.region
                };
                AuditLog.storeAuditLogs(volumeBody, "instance").then((resp) => {
                    if(resp === false);
                });
                this.setState({ message: i18n.t('vol_extend_success'), isAction: false, selectedVolume: volume, volumeList: this.getSortableData(this.state.columnType, volumeList), messgType: 'success' });
                return;
            }
            if(resp && typeof resp === 'string') {
                this.setState({ isAction: false, message: resp, messgType: 'error' });
                return;
            }
            if(resp && resp.badRequest && resp.badRequest.message) {
                this.setState({ isAction: false, message: getMessage(resp.badRequest.message), messgType: 'error' });
                return;
            }
            this.setState({ isAction: false, message: i18n.t('vol_extend_failure'), messgType: 'error' });
        });
    }



    detachInstance() {
        this.detachCancel();
        this.setState({ isAction: true });
        let instanceId = this.state.selectedVolume.attachments[0].server_id;
        let compRegionUrl = this.getComputeRegionUrl(this.state.selectedVolume.region);
        let volumeId = this.state.selectedVolume.id;
        let i18n = this.props.i18n;
        let logInstanceName = this.state.logInstanceDetachName;
        let logRegion = this.state.selectedVolume.region;
        let logVolume = this.state.selectedVolume.name;
        VolumeService.detachInstanceById(instanceId, volumeId,
            compRegionUrl, this.state.selectedVolume.region).then(resp => {
                if(resp === null) {
                    const volumeBody = {
                        "userId": localStorage.getItem("userId"),
                        "name": "Volume " + logVolume + " has been detached from instance " + logInstanceName,
                        "operation": "Volume Detach",
                        "region": logRegion
                    };
                    AuditLog.storeAuditLogs(volumeBody, "instance").then((resp) => {
                        if(resp === false);
                    });
                    this.removeAttachment(volumeId);
                    this.setState({ message: i18n.t('vol_dettach_success'), messgType: 'success', isAction: false });
                    return;
                }
                if(resp && resp.conflictingRequest) {
                    this.setState({ isAction: false, message: getMessage(resp.conflictingRequest.message), messgType: 'warning' });
                    return;
                }

                if(resp && typeof resp === 'string') {
                    this.setState({ isAction: false, message: resp, messgType: 'error' });
                    return;
                }

                this.setState({ isAction: false, message: i18n.t('vol_dettach_failure'), messgType: 'error' });
            });
    }

    removeAttachment(volumeId) {
        let volumes = this.state.volumeList;
        let volume = volumes.find(item => item.id === volumeId);
        volume.attachments = [];
        volume.status = 'available';
        this.setState({ volumeList: volumes });
    }
    attachAttachment(volumeId, volResp) {
        let volumes = this.state.volumeList;
        let volume = volumes.find(item => item.id === volumeId);
        volume.attachments = [{
            device: volResp.device,
            id: volResp.volumeId,
            server_id: volResp.serverId,
            volume_id: volResp.volumeId
        }];
        volume.status = 'in-use';
        this.setState({ volumeList: volumes });
    }

    createBackup() {
        let backupName = this.state.backupName;
        if(backupName === undefined || backupName.trim() === '') {
            this.setState({ errorMessg: 'Enter the name' });
            return;
        }
        backupName = backupName.trim();
        // else if(this.isSnapshotExist(this.state.backupName,this.state.selectedVolume.region)) {
        //     this.setState({ errorMessg: 'Name should not be duplicate' });
        //     return;
        // }
        this.setState({ isAction: true });
        this.backupCancel();
        let volumeId = this.state.selectedVolume.id;
        let requestBody = {
            "backup": {
                "name": backupName,
                "description": "Daily backup",
                "volume_id": volumeId
            }
        };
        if(this.state.selectedVolume.attachments.length > 0) {
            requestBody = {
                "backup": {
                    "name": backupName,
                    "description": "Daily backup",
                    "volume_id": volumeId,
                    "force": true
                }
            };
        }
        VolumeService.createBackupById(requestBody, this.state.selectedVolume.region).then(resp => {
            if(resp && resp.backup) {
                this.volSnapRef.current.setBackupList(true);
                this.setState({ isAction: false, message: 'Successfully created the volume backup ' + backupName, messgType: 'success', backupName: '' });
                const backupBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Volume backup " + backupName + " has been created from volume " + this.state.selectedVolume.name,
                    "operation": "Volume backup creation",
                    "region": this.state.selectedVolume.region
                };
                AuditLog.storeAuditLogs(backupBody, "instance").then((resp) => {
                    if(resp === false);
                });
                return;
            }
            if(resp && typeof resp === 'string') {
                this.setState({ isAction: false, message: resp, messgType: 'error' });
                return;
            }
            if(resp && resp.badRequest && resp.badRequest.message) {
                this.setState({ isAction: false, message: getMessage(resp.badRequest.message), messgType: 'error' });
                return;
            }
            this.setState({ isAction: false, message: 'Failed to create new backup. Try Again', messgType: 'error' });
        });
    }

    isSnapshotExist = (name, regionName) => {
        let snapshotList = JSON.parse(sessionStorage.snapshotList);
        let ob = snapshotList.find(item => item.region === regionName && item.name === name.trim());
        if(ob !== undefined) {
            return true;
        }
        return false;
    };
    backupClick = (event) => {
        this.setState({ errorMessg: '', backupName: this.state.selectedVolume.name + '-backup' });
        setTimeout(() => {
            document.getElementById('backupname1').focus();
        }, 400);
        $('.volSnapshot_slider').addClass('active');
    };

    renameClick = () => {
        this.setState({ renameName: this.state.selectedVolume.name, errorMessg: '' });
        $('.renameVolume_slider').addClass('active');
        setTimeout(() => {
            document.getElementById('renameName').focus();
        }, 400);
    };

    extendClick = () => {
        if(this.state.selectedVolume.size === 1000) {
            this.setState({ message: 'Current volume size has reached the extend limit', messgType: 'warning' });
            return;
        }
        this.setState({ extendVolume: this.state.selectedVolume.size, errorMessg: '' });
        $('.extendVolume_slider').addClass('active');
        setTimeout(() => {
            document.getElementById('extendVolume').focus();
        }, 400);
    };

    detachClick = () => {
        this.setState({ errorMessg: '' });
        $('.detach_settngVolume_popup').addClass('active');
        $("body").addClass("popup_no_scroll");

    };
    deleteClick = () => {
        this.setState({ errorMessg: '' });
        $('.delete_volume_popup').addClass('active');
        $("body").addClass("popup_no_scroll");

        document.getElementById('volDelBtn').focus();
    };
    retryClick() {
        this.retryCreation();
    }
    deleteCancelClick = () => {
        $('.delete_volume_popup').removeClass('active');
        $("body").removeClass("popup_no_scroll");
    };
    volumeCancel = () => {
        $('.createVolume_slider').removeClass('active');
        $("body").removeClass("popup_no_scroll");
        this.setState({
            isYearly: true
        });
    };
    backupCancel = () => {
        $('.volSnapshot_slider').removeClass('active');
    };
    renameCancel = () => {
        $('.renameVolume_slider').removeClass('active');
    };
    extendCancel = () => {
        $('.extendVolume_slider').removeClass('active');
    };
    detachCancel = () => {
        $('.detach_settngVolume_popup').removeClass('active');
        $("body").removeClass("popup_no_scroll");
    };
    attachCancel = () => {
        $('.attachVolume_slider').removeClass('active');
    };
    onVolKeydown = (e, type) => {
        if(e.keyCode === 13) {
            if(type === 'addvolume') {
                this.createVolume();
            } else if(type === 'rename') {
                this.renameVolume();
            } else if(type === 'backup') {
                this.createBackup();
            } else if(type === 'extend') {
                this.extendVolumeSize("before");
            }
        }
    };

    headerSortClick = (event) => {
        $('.volMainVolume_table .sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };

    setSortable = (type) => {
        if(type === "name") {
            this.setState({ nameToggle: !this.state.nameToggle }, () => this.setVolumeList(type));
        } else if(type === "region") {
            this.setState({ regionToggle: !this.state.regionToggle }, () => this.setVolumeList(type));
        } else if(type === "date") {
            this.setState({ dateToggle: !this.state.dateToggle }, () => this.setVolumeList(type));
        } else if(type === "attached") {
            this.setState({ attachedToggle: !this.state.attachedToggle }, () => this.setVolumeList(type));
        } else if(type === "size") {
            this.setState({ sizeToggle: !this.state.sizeToggle }, () => this.setVolumeList(type));
        } else if(type === "status") {
            this.setState({ statusToggle: !this.state.statusToggle }, () => this.setVolumeList(type));
        }
    };

    setVolumeList(type) {
        let volumeList = this.getSortableData(type, this.state.volumeList);
        let volumesPaged = volumeList;
        if(volumeList.length > this.state.count) volumesPaged = volumesPaged.slice(0, this.state.count);
        this.setState({ volumeList: volumeList, volumesPaged: volumesPaged, indexCount: 0 });
    }

    getSortableData = (type, items) => {
        if(items && items.length === 0) {
            return items;
        }
        this.setState({ columnType: type });
        if(type === "name") {
            if(this.state.nameToggle) {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                });
            }
            //this.setState({ nameToggle: !this.state.nameToggle});
            return items;
        }
        else if(type === "region") {
            if(this.state.regionToggle) {
                items.sort(function (a, b) {
                    if(a.fullRegion < b.fullRegion) { return -1; }
                    if(a.fullRegion > b.fullRegion) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.fullRegion < b.fullRegion) { return 1; }
                    if(a.fullRegion > b.fullRegion) { return -1; }
                    return 0;
                });
            }
            //this.setState({ regionToggle: !this.state.regionToggle })
            return items;
        }
        else if(type === "date") {
            if(this.state.dateToggle) {
                items.sort(function (a, b) {
                    return new Date(b.created_at) - new Date(a.created_at);
                });
            }
            else {
                items.sort(function (a, b) {
                    return new Date(a.created_at) - new Date(b.created_at);
                });
            }
            //this.setState({ dateToggle: !this.state.dateToggle })
            return items;
        }
        else if(type === "attached") {
            if(this.state.attachedToggle) {
                items.sort(function (a, b) {
                    if(a.instanceName < b.instanceName) { return -1; }
                    if(a.instanceName > b.instanceName) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.instanceName < b.instanceName) { return 1; }
                    if(a.instanceName > b.instanceName) { return -1; }
                    return 0;
                });
            }
            //this.setState({ attachedToggle: !this.state.attachedToggle})
            return items;
        } else if(type === "size") {
            if(this.state.sizeToggle) {
                items.sort(function (a, b) {
                    if(a.size < b.size) { return 1; }
                    if(a.size > b.size) { return -1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.size < b.size) { return -1; }
                    if(a.size > b.size) { return 1; }
                    return 0;
                });
            }
            //this.setState({ sizeToggle: !this.state.sizeToggle})
            return items;
        } else if(type === "status") {
            if(this.state.statusToggle) {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return 1; }
                    if(a.status > b.status) { return -1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return -1; }
                    if(a.status > b.status) { return 1; }
                    return 0;
                });
            }
            //this.setState({ sizeToggle: !this.state.sizeToggle})
            return items;
        }
        return items;
    };
    getRegionDropdown = () => {
        $(".regionSelect_options").addClass("active");
        $(".region_select_container").addClass("active");
        document.getElementById('regionId').focus();
        this.setState({ regionListFilter: this.state.regions, isregionselected: false, dropRegion: '' }, () => this.scrollTop());
    };
    scrollTop() {
        if(this.scrollRef && this.scrollRef.current && this.scrollRef.current.scrollArea) {
            this.scrollRef.current.scrollArea.scrollTop();
        }
    }
    getSelectedRegion = (event, regionOb) => {
        if(regionOb.status !== 1) {
            sessionStorage.inFocus = true;
            return;
        }
        sessionStorage.inFocus = false;
        $(".regionSelect_options").removeClass("active");
        if(regionOb.id !== this.state.selectedDropDown) {
            let instanceList = this.state.allInstanceList.filter(item => item.region === regionOb.id);
            this.setState({ instanceList: instanceList, selectedInstanceId: '' });
        }
        if(this.state.isUserSubscribed) {
            this.setState({ selectedRegion: regionOb.name, regionName: regionOb.id, countryName: regionOb.countryName, errorMessg: '', isregionselected: true, selectedDropDown: regionOb.id, selectedInstanceId: '', regionErrorMessg: '', dropRegion: '' });
        }
        else {
            this.setState({ selectedRegion: regionOb.name, regionName: regionOb.id, countryName: regionOb.countryName, selectedRegionUrl: this.getVolumeRegionUrl(regionOb.id), errorMessg: '', isregionselected: true, selectedDropDown: regionOb.id, regionErrorMessg: '', dropRegion: '' });
        }

    };
    filterDropDown = (event) => {
        $(".regionSelect_options").addClass("active");
        let name = event.target.name;
        let val = event.target.value;
        let lcVal = val.toLowerCase();
        let items = this.state.regions.filter(item => item.id.toLowerCase().includes(lcVal) || item.name.toLowerCase().includes(lcVal));

        this.setState({ regionListFilter: items, dropRegion: val });
    };

    onFocusOut = (e) => {
        e.stopPropagation();
        if(!e.currentTarget.contains(e.relatedTarget)) {
            if(sessionStorage.inFocus === true) {
                sessionStorage.inFocus = false;
                return;
            }
            if(this.state.selectedRegion !== '') {
                this.setState({ dropRegion: '', isregionselected: true });
            } else if(this.state.selectedRegion === '') {
                this.setState({ dropRegion: '', isregionselected: false });
            }
            $(".regionSelect_options").removeClass('active');
            $(".region_select_container").removeClass("active");
        }
    };

    componentWillUnmount() {
        clearTimeout(sessionStorage.volumeInterval);
        document.removeEventListener("keyup", this.escfunction, false);
    }

    handleNextClick = (event) => {
        let volumeList = this.state.volumeList;
        let indexCount = this.state.indexCount + this.state.count;
        let endCount = indexCount + this.state.count;
        if(endCount > volumeList.length) endCount = volumeList.length;
        this.setState({
            indexCount: indexCount,
            volumesPaged: volumeList.slice(indexCount, endCount)
        });
        event.preventDefault();
    };

    handlePreviousClick = (event) => {
        let volumeList = this.state.volumeList;
        let indexCount = this.state.indexCount - this.state.count;
        this.setState({
            indexCount: this.state.indexCount - this.state.count,
            volumesPaged: volumeList.slice(indexCount, this.state.indexCount)
        });
        event.preventDefault();
    };

    setYearlyFlag = (flag) => {
        this.setState({
            isYearly: flag,
            isregionselected: false,
            selectedRegionUrl: '',
            selectedInstanceId: '',
            selectedInstanceName: '',
            selectedRegion: '',
            errorMessg: '',
            nameErrorMessg: '',
            sizeErrorMessg: '',
            regionErrorMessg: '',
            volumeName: '',
            size: '',
            regionName: '',
            selectedDropDown: '',
            dropRegion: ''
        });
    };

    render() {
        if(this.state.isRedirectToCCPage) {
            return <Redirect to={ {
                pathname: "/billing/creditcard",
                state: { message: true }
            } }></Redirect>;
        }

        return (
            <body className={ this.state.isRegionStatus && this.state.regionCount > 0 && this.state.isCluster == "show" ? "main_nav_module volumes_main_module important_msg" : "main_nav_module volumes_main_module" }>
                <main>

                    <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                        <div className="loader_icon"></div>
                    </div>
                    <div className="common_user_message cluster_msg cluster_uiNew" style={ { display: this.state.isRegionStatus && this.state.regionCount > 0 && this.state.isCluster == "show" ? "" : "none" } }>
                        <div className="message_content">
                            { this.state.regionCount == 1 ?
                                <p><span className="cm_title">Region <b>{ this.state.regionString }</b> is under maintenance.  </span>
                                    You will not be able to create resources e.g. instances, volumes, etc., in this region and the existing resources may also become inaccessible during this period. We are trying to resolve this at the earliest. Thank you for your patience.
                                    <a href="https://status.idrivecompute.com/" target="_blank" className="check-status-btn">Check Status</a>
                                </p>
                                :
                                <p><span className="cm_title">Regions <b>{ this.state.regionString }</b> are under maintenance.  </span>
                                    You will not be able to create resources e.g. instances, volumes, etc., in this region and the existing resources may also become inaccessible during this period. We are trying to resolve this at the earliest. Thank you for your patience.
                                    <a href="https://status.idrivecompute.com/" target="_blank" className="check-status-btn">Check Status</a>
                                </p>
                            }
                            <span className="close_icon" data-tip data-for="closeCluster" onClick={ () => { this.setState({ isRegionStatus: false }); localStorage.setItem("clusterMessage", "hide"); } }></span>
                            <ReactToolTip id="closeCluster" place="left" effect="solid">Close</ReactToolTip>
                        </div>
                    </div>
                    <LeftNav isActive={ 'volumes' }></LeftNav>

                    <div className="main_container">
                        <header className="header_wrap">
                            <HeaderTop showCreate={ true } isUserSubscribed={ this.state.isUserSubscribed }></HeaderTop>
                            <div className="header_wrap_bottom">
                                <div className="bottom_navbar">
                                    <div className="bn_left">
                                        <div className="computer_no">
                                            <span className="text bold_600">Volumes</span>
                                        </div>
                                        {/* <p className="head_info">Create block storage volumes to expand the storage space of your virtual instances</p> */ }
                                    </div>
                                    { this.state.volumeList.length > 0 ?
                                        <div className="bn_right">
                                            <div className="rhs_info">
                                                { this.state.isTabActive ? <p>Number of volumes : { this.state.volumeList.length }</p> :
                                                    <p>Number of backups : { sessionStorage.backupsLength }</p>
                                                }
                                            </div>
                                            <div className="divider" style={ { display: this.state.isTabActive ? '' : 'none' } }></div>
                                            <div className="rhs_cta" style={ { display: this.state.isTabActive ? '' : 'none' } }>
                                                <div className="btn_wrap_icon btnDefaultPad" >
                                                    <input type="button" name="" value="Add Volume" disabled={ this.state.isCreateExternalDisabled } className={ this.state.isCreateExternalDisabled ? "common_cta_btn blue createVolume_cta disabled" : "common_cta_btn blue createVolume_cta" }
                                                        onClick={ () => this.onAddVolumeClick() }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        : "" }
                                </div>
                            </div>
                        </header>
                        <NotificationSlider />
                        <section className="main_section pagination__wrap">
                            <div className="main_body_container">
                                <div className="mainBody_colWrap">
                                    <div className="user_container">
                                        <div className="volumeMain_table vtabs">
                                            <div className="volMain_tab_wrap">
                                                <div className="custom_tabs_wrap">
                                                    <ul>
                                                        <li className={ this.state.isTabActive ? "volMainVolume active" : "volMainVolume" } onClick={ () => this.setState({ isTabActive: true }, () => this.activateActionMenu1()) }>Volumes</li>
                                                        <li className={ this.state.isTabActive ? "volMainSnapshot" : "volMainSnapshot active" } onClick={ () => this.setState({ isTabActive: false }, () => this.activateActionMenu1()) }>Backups</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="tabular_data_wrap volMainVolume_table column_7" style={ { display: this.state.isTabActive ? 'block' : 'none' } }>
                                                <div className="table_header">
                                                    <ul>
                                                        <li className="th">
                                                            <div className="col col1">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("name"); } }>Name<span className="sort_icon" ></span></div>
                                                            </div>
                                                            <div className="col col2">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("size"); } }>Size<span className="sort_icon"></span></div>
                                                            </div>
                                                            <div className="col col3">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("region"); } }>Region<span className="sort_icon"></span></div>
                                                            </div>
                                                            <div className="col col4">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("attached"); } }>Attached To<span className="sort_icon"></span></div>
                                                            </div>
                                                            <div className="col col7">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("status"); } }>Status<span className="sort_icon"></span></div>
                                                            </div>
                                                            <div className="col col5">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("date"); } }>Created On<span className="sort_icon active"></span></div>
                                                            </div>
                                                            <div className="col col6">Actions</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="table_data">
                                                    <ul>{ this.state.volumesPaged.length === 0 && !this.state.isAction ? <div className="outer_empty_wrap fullPageEmpty">
                                                        <div className="inner_empty_wrap">
                                                            <div className="svg_wrap empty_icon volumeCreate_empty"></div>
                                                            <p className="empty_head">Volumes</p>
                                                            <p className="empty_title">Add block storage volumes to expand the storage capacity of your compute instances.</p>
                                                            <div className="cta_wrap"> <input type="button" disabled={ this.state.isCreateExternalDisabled } value="Add Volume" className={ this.state.isCreateExternalDisabled ? "common_cta_btn blue disabled" : "common_cta_btn blue" } onClick={ () => this.onAddVolumeClick() } /></div>
                                                        </div>
                                                    </div> : this.state.volumesPaged.map((volume, i) =>
                                                        <li className={ volume.status.toLowerCase() == "reserved" ? volume.status + " tr disabled" : volume.status + " tr" } key={ i }>
                                                            <div className="col col1">
                                                                <div className="name_icon">
                                                                    <span className="svg_wrap"><svg x="0px" y="0px" width="30px" height="24.3px" viewBox="0 0 30 24.3" enableBackground="new 0 0 30 24.3" xmlSpace="preserve">
                                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#59A7DA" d="M29,12.7v8c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2v-8  c0-0.2,0-0.8,0-1.4c0-0.1,0-0.6,0.2-1L4,3.7c0.7-1.3,1.4-1.9,3-2h16c1.7-0.1,2,0.6,2.9,1.9l2.9,6.8C29.1,10.9,29,12.7,29,12.7z   M3,19.7c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1v-6c0-0.6-0.4-1-1-1H4c-0.6,0-1,0.4-1,1V19.7z M26,9.7l-2-5c-0.2-0.5-0.4-1-1-1H7  c-0.6,0-0.8,0.5-1,1l-2,5c-0.2,0.3-0.3,0.9,0,1h22C26.4,10.7,26.2,10,26,9.7z M6,15.7h12c0.6,0,1,0.4,1,1s-0.4,1-1,1H6  c-0.6,0-1-0.4-1-1S5.4,15.7,6,15.7z M24,15.7c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S23.4,15.7,24,15.7z"></path>
                                                                    </svg>
                                                                    </span>
                                                                </div><span data-tip data-for={ volume.name }>{ volume.name }</span>
                                                                { volume.name && volume.name.length > 25 ?
                                                                    <ReactToolTip id={ volume.name } effect='solid' place='top'>{ volume.name }</ReactToolTip> : null
                                                                }
                                                            </div>
                                                            <div className="col col2"><span> { volume.size } GB </span></div>
                                                            <div className="col col3"><span>{ volume.fullRegion }</span></div>

                                                            <div className="col col4" ><span data-tip data-for={ volume.id }>{ this.getInstanceName(volume) }</span>
                                                                { volume.instanceName && volume.instanceName.length > 27
                                                                    ? <ReactToolTip effect="solid" id={ volume.id }>{ volume.instanceName }</ReactToolTip> : null
                                                                }

                                                            </div>
                                                            <div className="col col7"><span>{ volume.status.toString().toUpperCase() }</span></div>
                                                            <div className="col col5"><span>{ formatDate(new Date(volume.created_at)) }</span></div>
                                                            <div className="col col6">
                                                                <span className="menu_icon" onClick={ (e) => this.onRowMenuClick(e, volume) }><span className="svg_wrap"><svg className="horizMenuIcon" data-tip data-for="actions" x="0px" y="0px" viewBox="0 0 22.1 6.3" enableBackground="new 0 0 22.1 6.3" xmlSpace="preserve">
                                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#8692B0" d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                                                                </svg><ReactToolTip id="actions" place="top" effect="solid">Actions</ReactToolTip></span>
                                                                    <ul className="dropdown_component volumes_row_options">
                                                                        <span className="arrow_pointer"></span>
                                                                        <li className="bck_create" style={ { display: volume.status === 'error' ? 'none' : 'block' } } onClick={ (e) => this.backupClick(e) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M448.8,287.9H288.5v160.3c0,17.7-14.4,32.1-32.1,32.1l0,0  c-17.7,0-32.1-14.4-32.1-32.1V287.9H64.1c-17.7,0-32.1-14.4-32.1-32.1s14.4-32.1,32.1-32.1h160.3V63.5c0-17.7,14.4-32.1,32.1-32.1  l0,0c17.7,0,32.1,14.4,32.1,32.1v160.3h160.3c17.7,0,32.1,14.4,32.1,32.1S466.5,287.9,448.8,287.9z"></path>
                                                                        </svg></span></span>Create Backup</li>
                                                                        <li className="rename" style={ { display: volume.status === 'error' ? 'none' : 'block' } } onClick={ () => this.renameClick() }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve">
                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                                                        </svg></span></span>Rename</li>
                                                                        <li className="extend" style={ { display: volume.attachments.length > 0 || volume.status === 'error' ? 'none' : 'block' } } onClick={ () => this.extendClick() }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 18.6 18.6" enableBackground="new 0 0 18.6 18.6" xmlSpace="preserve">
                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M17.3,18.3h-5c-0.6,0-1-0.4-1-1s0.4-1,1-1h2.6L10.6,12l1.4-1.4  l4.3,4.3v-2.6c0-0.6,0.4-1,1-1s1,0.4,1,1v5C18.3,17.8,17.9,18.3,17.3,18.3z M15.3,8.3c-0.6,0-1-0.4-1-1v-3h-3c-0.6,0-1-0.4-1-1  s0.4-1,1-1h4c0.6,0,1,0.4,1,1v4C16.3,7.8,15.9,8.3,15.3,8.3z M7.3,16.3h-4c-0.6,0-1-0.4-1-1v-4c0-0.6,0.4-1,1-1s1,0.4,1,1v3h3  c0.6,0,1,0.4,1,1S7.9,16.3,7.3,16.3z M6.6,8L2.3,3.7v2.6c0,0.6-0.4,1-1,1s-1-0.4-1-1v-5c0-0.6,0.4-1,1-1h5c0.6,0,1,0.4,1,1  s-0.4,1-1,1H3.7L8,6.6L6.6,8z"></path>
                                                                        </svg></span></span>Extend</li>
                                                                        <li className="attach" style={ { display: volume.attachments.length > 0 || volume.status === 'error' ? 'none' : 'block' } } onClick={ () => this.onAttachClick() }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 18.6 18.6" enableBackground="new 0 0 18.6 18.6" xmlSpace="preserve">
                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M2.5,16.5C0,14,0.1,9.7,2.9,6.9l3-3l0,0l2-2c2-2,5.5-2.5,7.4-0.6  c1.9,1.9,1.3,5.2-0.8,7.2l-5.3,5.3c-1.3,1.3-2.8,1.2-4,0s-1.3-2.7,0-4l6-6l1.3,1.3l-6,6c-0.6,0.5-0.5,0.8,0,1.3  c0.5,0.5,0.8,0.5,1.3,0l5.3-5.3c1.3-1.3,2-3.4,0.8-4.5C12.8,1.5,10.5,2,9.2,3.3L3.9,8.6c-2,2-1.9,4.7,0,6.6s4.6,2,6.7,0l6-6l1.3,1.3  l-5.7,5.6C9.4,19,5.1,19.1,2.5,16.5z"></path>
                                                                        </svg></span></span>Attach</li>
                                                                        <li className="detach" style={ { display: volume.attachments.length > 0 && volume.status !== 'error' ? 'block' : 'none' } } onClick={ () => this.detachClick() }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 18.6 18.6" enableBackground="new 0 0 18.6 18.6" xmlSpace="preserve">
                                                                            <g>
                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M5.2,13.9c1.2,1.2,2.7,1.3,4,0l1.3-1.3l-1.3-1.3l-1.3,1.3   c-0.6,0.5-0.8,0.5-1.3,0c-0.5-0.5-0.6-0.8,0-1.3l1.3-1.3L6.5,8.6L5.2,9.9C3.9,11.2,4,12.7,5.2,13.9z"></path>
                                                                                <polygon fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" points="15.2,13.2 17.9,10.6 16.5,9.3 13.9,11.9  "></polygon>
                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M7.3,5.2l1.9-1.9C10.5,2,12.8,1.5,14,2.7c1.2,1.2,0.5,3.3-0.8,4.5   l-2,1.9l1.3,1.3l2-1.9c2-2,2.6-5.3,0.8-7.2C13.4-0.5,9.9,0,7.9,2L5.9,3.9L7.3,5.2z"></path>
                                                                                <polygon fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" points="11.2,4 8.6,6.6 9.9,7.9 12.5,5.3  "></polygon>
                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M11.9,13.9l-1.3,1.3c-2,2-4.8,1.9-6.7,0c-1.9-1.9-2-4.6,0-6.6   l1.3-1.3L3.9,5.9l-1,1C0.1,9.7,0,14,2.5,16.5c2.6,2.6,6.9,2.4,9.7-0.3l1-1L11.9,13.9z"></path>
                                                                            </g>
                                                                            <rect x="7.8" y="1.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -4.946 9.1295)" fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" width="1.5" height="18"></rect>
                                                                        </svg></span></span>Detach</li>
                                                                        <li className="retry" style={ { display: volume.status === 'error' ? '' : 'none' } } onClick={ () => this.retryClick() }><span className="icon"> <span className="svg_wrap">
                                                                            <svg width="6.35mm" height="6.35mm" viewBox="0 0 18 18">
                                                                                <path d="M8.9.5a8.53,8.53,0,0,1,8.5,8h-2a6.51,6.51,0,1,0-6.5,7A6.43,6.43,0,0,0,13,14l-2.5-2.5h6v6l-2-2a8.27,8.27,0,0,1-5.5,2A8.49,8.49,0,0,1,.5,9,8.41,8.41,0,0,1,8.9.5Z" fill="#4c8ccd" fillRule="evenodd"></path>
                                                                            </svg>
                                                                        </span></span>Retry</li>
                                                                        <li className="delete" style={ { display: (volume.attachments.length > 0 && volume.status !== 'error') ? 'none' : 'block' } } onClick={ () => this.deleteClick() }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M433.5,116.8v303.5c0,27.9-22.7,50.6-50.6,50.6H129.9  c-28,0-50.6-22.7-50.6-50.6V116.8H54.1V66.2h75.9h25.3V40.9h202.4v25.3h25.3h75.9v50.6H433.5z M382.9,116.8H129.9v303.5h252.9V116.8  z M231.1,369.7h-50.6V167.4h50.6V369.7z M332.3,369.7h-50.6V167.4h50.6V369.7z"></path>
                                                                        </svg></span></span>Delete</li>
                                                                    </ul>
                                                                </span></div>
                                                            <div className="boot_container" style={ { display: volume.status === 'creating' ? '' : 'none' } }>
                                                                <div className="boot_wrapper">
                                                                    <div className="progress_wrap">
                                                                        <div className="title_head">
                                                                            <span className="head_title">Volume creation is in progress</span><span className="percent_num"></span>
                                                                        </div>
                                                                        <div className="progress_bar">
                                                                            <span className="percent_progress" style={ { width: '100%' } }></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>

                                                    )
                                                    }
                                                    </ul>

                                                </div>
                                                <div className="pagination_inner__box remove-bg" style={ { display: this.state.volumeList.length > this.state.count ? '' : 'none' } }>
                                                    <div className="Page_navigation">
                                                        <ul className="pagination_ul">
                                                            <li className={ this.state.indexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page" onClick={ (event) => { this.handlePreviousClick(event); } }>
                                                                    <ReactToolTip id="prev-page" place="top" effect="solid">Previous</ReactToolTip>
                                                                    <span aria-hidden="true">«</span>
                                                                    <span className="sr-only">Previous</span>
                                                                </a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                    { this.state.indexCount + 1 } - { (this.state.indexCount + this.state.count) > this.state.volumeList.length ? this.state.volumeList.length : (this.state.indexCount + this.state.count) }
                                                                </a>
                                                            </li>
                                                            <li className={ this.state.indexCount + this.state.count > this.state.volumeList.length - 1 ? "page-item disabled" : "page-item" }>
                                                                <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page" onClick={ (event) => { this.handleNextClick(event); } }>
                                                                    <ReactToolTip id="next-page" place="top" effect="solid">Next</ReactToolTip>
                                                                    <span aria-hidden="true">»</span>
                                                                    <span className="sr-only">Next</span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                            </div>
                                            <VolumeBackup isTabActive={ this.state.isTabActive } ref={ this.volSnapRef }
                                                bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) }
                                                msgHandler={ (msg, mesgType) => this.setState({ message: msg, messgType: mesgType }) }
                                                refreshVolList={ () => this.setAllVolumes(this.state.columnType) }
                                                volumeList={ this.state.volumeList }
                                                regionList={ this.state.regionList } />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <div className="main_slider createVolume_slider">
                            <div className="slider_bg_shadow"></div>
                            <div className="slider_wrapper">
                                <div className="main_slider_container">
                                    <div className="close_icon" onClick={ () => this.volumeCancel() }></div>
                                    <div className="createVol_slide_wrap">
                                        <div className="head_block">
                                            <h2><span className="icon_img"> <span className="icon"></span> </span>Add Volume</h2>
                                        </div>
                                        <div className="vol_contWrap">
                                            <ul className="volSliderTab">
                                                <li className={ this.state.isYearly ? "volTablist volYearlyList active" : "volTablist volYearlyList" } onClick={ () => this.setYearlyFlag(true) } >Yearly</li>
                                                <li className={ this.state.isYearly ? "volTablist volMonthlyList" : "volTablist volMonthlyList active" } onClick={ () => this.setYearlyFlag(false) }>Monthly</li>
                                            </ul>
                                            <div id="volYearly" className="createVol_content_wrap volYearly" style={ { display: this.state.isYearly ? "block" : "none" } }>
                                                <div className="offer-text-blk">
                                                    <p className="saveoffer-txt"><span className="red-hht-txt">{ this.state.discPerce }%<sup>*</sup></span> OFF for the first year</p>
                                                </div>
                                                <div className="volsliderInnerWrap">
                                                    <p className="info_txt">
                                                        Volumes are billed at <span className="old-price">${ (this.state.volPrice * 12).toFixed(2) }</span>/GB/Year <b>${ ((this.state.volPrice * 12) - ((this.state.volPrice * 12) / this.state.discVal)).toFixed(2) }</b>/GB for the first year.
                                                    </p>
                                                    <p className="info_txt">The size of your volume may range from 1 GB to 1 TB (1000 GB).
                                                        For yearly volumes, the size must be greater than 10 GB and for monthly volumes it must be greater than 1 GB.</p>
                                                    <p>Volume will be created and attached to the selected instance.</p>
                                                    <p className="info_txt"><strong>Note:</strong> Volumes cannot be attached to Bare metal instances.</p>
                                                    <div className="common_txtBox_row">
                                                        <label>Name</label>
                                                        <input placeholder="Provide a volume name" name="volumeName" id="volumeName" value={ this.state.volumeName } onChange={ (e) => this.formHandler(e) } className="txt_box" onKeyDown={ (e) => this.onVolKeydown(e, 'addvolume') } autoComplete="chrome-off" />
                                                        <span className="comm_error_msg">{ this.state.nameErrorMessg }</span>
                                                    </div>
                                                    <div className="common_txtBox_row">
                                                        <label>Size</label>
                                                        <div className="txtBox_wrap">
                                                            <input type="text" placeholder="Enter a volume size between 1 GB to 1000 GB" name="size" id="size" value={ this.state.size } className="txt_box" onChange={ (e) => this.formHandler(e) } onKeyDown={ (e) => this.onVolKeydown(e, 'addvolume') } autoComplete="chrome-off" />
                                                            <span className="label_unit">GB</span> </div>
                                                        <span className="comm_error_msg">{ this.state.sizeErrorMessg }</span>
                                                        {/* <label style={{display:'block'}}>Enter a volume size between 1 GB to 1 TB</label> */ }
                                                    </div>

                                                    <div className="common_txtBox_row region_select" onBlur={ (e) => this.onFocusOut(e) }>
                                                        <label>Regions</label>
                                                        <div className="region_select_container" >
                                                            <div className="slectBox" onClick={ this.getRegionDropdown }>
                                                                <div className={ this.state.isregionselected ? "search_inp_box optSelect" : "search_inp_box optUnselect" }>
                                                                    <textarea id="regionId" name="dropRegion" value={ this.state.dropRegion } placeholder="Select a Region" onChange={ this.filterDropDown } autoComplete="chrome-off"></textarea>
                                                                </div>
                                                                <ul>
                                                                    <li className="selected_elem"><span className={ "country_flag " + this.state.countryName.toLowerCase() }></span>{ this.state.selectedRegion } ({ this.state.regionName })</li>
                                                                </ul>
                                                                <span className="dropArrow"> <svg className="header_nav_dropdown" viewBox="0 0 10 5">
                                                                    <title>drop-down</title>
                                                                    <polygon className="cls-1" points="5 5 0 0 10 0 5 5"></polygon>
                                                                </svg>
                                                                </span>
                                                            </div>
                                                            <div className="regionSelect_options">

                                                                { this.state.regionListFilter.length <= 0 ?
                                                                    <ul className="noSearchRes" style={ { display: this.state.regionListFilter.length <= 0 ? "" : "none" } }>
                                                                        <li>No matching region found</li>
                                                                    </ul>
                                                                    :
                                                                    <ul>
                                                                        <ScrollArea ref={ this.scrollRef }
                                                                            speed={ 0.8 }
                                                                            style={ { maxHeight: "245px" } }
                                                                            vertical={ true }
                                                                            horizontal={ false }
                                                                            minScrollSize={ 10 }
                                                                            smoothScrolling={ false }
                                                                            verticalScrollbarStyle={ { backgroundColor: "#C1C1C1", opacity: "1" } }
                                                                            verticalContainerStyle={ { backgroundColor: "#F1F1F1", opacity: "1" } }
                                                                            stopScrollPropagation={ true }
                                                                        >
                                                                            { this.state.regionListFilter.map((region, i) =>
                                                                                <li className={ "option_elem " + region.statusClass } key={ i } onMouseDown={ (e) => this.getSelectedRegion(e, region) } disabled={ region.status !== 1 }><span className={ 'country_flag ' + region.countryName.toLowerCase() } ></span>{ region.name } ({ region.id })<span className="algin_right__arrow" style={ { display: region.status === 1 ? 'none' : '' } }>{ region.statusName }</span>
                                                                                </li>
                                                                            ) }
                                                                        </ScrollArea>

                                                                    </ul>
                                                                }
                                                            </div>
                                                        </div>
                                                        <span className="comm_error_msg">{ this.state.regionErrorMessg }</span>
                                                    </div>
                                                    <div className="common_txtBox_row volume_instance" style={ { paddingTop: '0px' } }>
                                                        <label>Instances</label>
                                                        <div className="custom_select_box">
                                                            <select name="allInstance" value={ this.state.selectedInstanceId } onChange={ (e) => this.formHandler(e) }>
                                                                { this.state.instanceList.length === 0 ? <option value='' default>No instance available</option> : <option value='' style={ { display: "none" } } default>Select an instance to attach the volume</option> }
                                                                { this.state.instanceList.length > 0 && this.state.instanceList.map((instance, j) =>
                                                                    <option key={ j } style={ { display: instance.status === 'SHELVED_OFFLOADED' ? "none" : "" } } value={ instance.id } >{ instance.name }</option>
                                                                ) }
                                                            </select>
                                                        </div>
                                                        <span className="comm_error_msg">{ this.state.errorMessg }</span>
                                                        { this.state.instanceList.length === 0 ? <p className="info_txt" >Create an instance to attach</p> : <p className="info_txt" >Attach the volume to an instance</p> }
                                                    </div>
                                                    <div className="cta_wrap">
                                                        <input type="button" name="" value="Create Volume" disabled={ this.isCreateExternalDisabled } className={ this.isCreateExternalDisabled ? "common_cta_btn blue" : "common_cta_btn blue" } onClick={ () => this.createVolume() } />
                                                        <input type="button" name="" value="Cancel" className="common_cta_btn transparentGrey" onClick={ () => this.volumeCancel() } />
                                                    </div>
                                                    <div className="common_txtBox_row">
                                                        <b>Note:</b>
                                                        <p>- The { this.state.discPerce }% offer is applicable for the first year only. For subsequent years, normal charges are applicable.</p>
                                                        <p>- Any charges incurred for the volume will not be refunded on deleting the volume.</p>
                                                        <p>- To add a volume greater than 1000 GB, <a href="https://www.idrivecompute.com/support.htm" target="_blank">contact support</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="volMonthly" className="createVol_content_wrap volMonthly" style={ { display: this.state.isYearly ? "none" : "block" } }>
                                                <div className="offer-text-blk">
                                                    <p className="saveoffer-txt">Pay as you use with monthly plan</p>
                                                </div>
                                                <div className="volsliderInnerWrap">
                                                    <p className="info_txt">
                                                        Volumes are billed per month at <b>${ this.state.volPrice }/GB</b>.
                                                    </p>
                                                    <p className="info_txt">The size of your volume may range from 1 GB to 1 TB (1000 GB).
                                                        For yearly volumes, the size must be greater than 10 GB and for monthly volumes it must be greater than 1 GB</p>
                                                    <p>Volume will be created and attached to the selected instance.</p>
                                                    <p className="info_txt"><strong>Note:</strong> Volumes cannot be attached to Bare metal instances.</p>



                                                    <div className="common_txtBox_row">
                                                        <label>Name</label>
                                                        <input placeholder="Provide a volume name" name="volumeName" id="volumeName" value={ this.state.volumeName } onChange={ (e) => this.formHandler(e) } className="txt_box" onKeyDown={ (e) => this.onVolKeydown(e, 'addvolume') } autoComplete="chrome-off" />
                                                        <span className="comm_error_msg">{ this.state.nameErrorMessg }</span>
                                                    </div>
                                                    <div className="common_txtBox_row">
                                                        <label>Size</label>
                                                        <div className="txtBox_wrap">
                                                            <input type="text" placeholder="Enter a volume size between 1 GB to 1000 GB" name="size" id="size" value={ this.state.size } className="txt_box" onChange={ (e) => this.formHandler(e) } onKeyDown={ (e) => this.onVolKeydown(e, 'addvolume') } autoComplete="chrome-off" />
                                                            <span className="label_unit">GB</span> </div>
                                                        <span className="comm_error_msg">{ this.state.sizeErrorMessg }</span>
                                                        {/* <label style={{display:'block'}}>Enter a volume size between 1 GB to 1 TB</label> */ }
                                                    </div>

                                                    <div className="common_txtBox_row region_select" onBlur={ (e) => this.onFocusOut(e) }>
                                                        <label>Regions</label>
                                                        <div className="region_select_container" >
                                                            <div className="slectBox" onClick={ this.getRegionDropdown }>
                                                                <div className={ this.state.isregionselected ? "search_inp_box optSelect" : "search_inp_box optUnselect" }>
                                                                    <textarea id="regionId" name="dropRegion" value={ this.state.dropRegion } placeholder="Select a Region" onChange={ this.filterDropDown } autoComplete="chrome-off"></textarea>
                                                                </div>
                                                                <ul>
                                                                    <li className="selected_elem"><span className={ "country_flag " + this.state.countryName.toLowerCase() }></span>{ this.state.selectedRegion } ({ this.state.regionName })</li>
                                                                </ul>
                                                                <span className="dropArrow"> <svg className="header_nav_dropdown" viewBox="0 0 10 5">
                                                                    <title>drop-down</title>
                                                                    <polygon className="cls-1" points="5 5 0 0 10 0 5 5"></polygon>
                                                                </svg>
                                                                </span>
                                                            </div>
                                                            <div className="regionSelect_options">

                                                                { this.state.regionListFilter.length <= 0 ?
                                                                    <ul className="noSearchRes" style={ { display: this.state.regionListFilter.length <= 0 ? "" : "none" } }>
                                                                        <li>No matching region found</li>
                                                                    </ul>
                                                                    :
                                                                    <ul>
                                                                        <ScrollArea ref={ this.scrollRef }
                                                                            speed={ 0.8 }
                                                                            style={ { maxHeight: "245px" } }
                                                                            vertical={ true }
                                                                            horizontal={ false }
                                                                            minScrollSize={ 10 }
                                                                            smoothScrolling={ false }
                                                                            verticalScrollbarStyle={ { backgroundColor: "#C1C1C1", opacity: "1" } }
                                                                            verticalContainerStyle={ { backgroundColor: "#F1F1F1", opacity: "1" } }
                                                                            stopScrollPropagation={ true }
                                                                        >
                                                                            { this.state.regionListFilter.map((region, i) =>
                                                                                <li className={ "option_elem " + region.statusClass } key={ i } onMouseDown={ (e) => this.getSelectedRegion(e, region) } disabled={ region.status !== 1 }><span className={ 'country_flag ' + region.countryName.toLowerCase() } ></span>{ region.name } ({ region.id })<span className="algin_right__arrow" style={ { display: region.status === 1 ? 'none' : '' } }>{ region.statusName }</span>
                                                                                </li>
                                                                            ) }
                                                                        </ScrollArea>

                                                                    </ul>
                                                                }
                                                            </div>
                                                        </div>
                                                        <span className="comm_error_msg">{ this.state.regionErrorMessg }</span>
                                                    </div>
                                                    <div className="common_txtBox_row volume_instance" style={ { paddingTop: '0px' } }>
                                                        <label>Instances</label>
                                                        <div className="custom_select_box">
                                                            <select name="allInstance" value={ this.state.selectedInstanceId } onChange={ (e) => this.formHandler(e) }>
                                                                { this.state.instanceList.length === 0 ? <option value='' default>No instance available</option> : <option value='' style={ { display: "none" } } default>Select an instance to attach the volume</option> }
                                                                { this.state.instanceList.length > 0 && this.state.instanceList.map((instance, j) =>
                                                                    <option key={ j } style={ { display: instance.status === 'SHELVED_OFFLOADED' ? "none" : "" } } value={ instance.id } >{ instance.name }</option>
                                                                ) }
                                                            </select>
                                                        </div>
                                                        <span className="comm_error_msg">{ this.state.errorMessg }</span>
                                                        { this.state.instanceList.length === 0 ? <p className="info_txt" >Create an instance to attach</p> : <p className="info_txt" >Attach the volume to an instance</p> }
                                                    </div>
                                                    <div className="cta_wrap">

                                                        <input type="button" name="" value="Create Volume" className="common_cta_btn blue" onClick={ () => this.createVolume() } />
                                                        <input type="button" name="" value="Cancel" className="common_cta_btn transparentGrey" onClick={ () => this.volumeCancel() } />

                                                    </div>
                                                    <div className="common_txtBox_row">
                                                        <b>Note:</b>
                                                        To add a volume greater than 1000 GB, <a href="https://www.idrivecompute.com/support.htm" target="_blank">contact support</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="main_slider renameVolume_slider">
                            <div className="slider_bg_shadow"></div>
                            <div className="slider_wrapper">
                                <div className="main_slider_container">
                                    <div className="close_icon" onClick={ () => this.renameCancel() }></div>
                                    <div className="createVol_slide_wrap">
                                        <div className="head_block">
                                            <h2><span className="svg_wrap"><svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                            </svg></span>Rename { this.state.selectedVolume.name }</h2>
                                        </div>
                                        <div className="createVol_content_wrap">
                                            <div className="common_txtBox_row">
                                                <label>Name</label>
                                                <input type="text" placeholder="Provide a new name" name="renameName" id="renameName" value={ this.state.renameName } className="txt_box" onChange={ (e) => this.formHandler(e) } onKeyDown={ (e) => this.onVolKeydown(e, 'rename') } autoComplete="off" />
                                                <span className="comm_error_msg">{ this.state.errorMessg }</span>
                                            </div>
                                            <div className="cta_wrap">
                                                <input type="button" name="" value="Save Changes" onClick={ () => this.renameVolume() } className="common_cta_btn blue" />
                                                <input type="button" name="" value="Cancel" onClick={ () => this.renameCancel() } className="common_cta_btn transparentGrey" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="main_slider extendVolume_slider">
                            <div className="slider_bg_shadow"></div>
                            <div className="slider_wrapper">
                                <div className="main_slider_container">
                                    <div className="close_icon" onClick={ () => this.extendCancel() }></div>
                                    <div className="createVol_slide_wrap">
                                        <div className="head_block">
                                            <h2><span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 18.6 18.6" enableBackground="new 0 0 18.6 18.6" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M17.3,18.3h-5c-0.6,0-1-0.4-1-1s0.4-1,1-1h2.6L10.6,12l1.4-1.4  l4.3,4.3v-2.6c0-0.6,0.4-1,1-1s1,0.4,1,1v5C18.3,17.8,17.9,18.3,17.3,18.3z M15.3,8.3c-0.6,0-1-0.4-1-1v-3h-3c-0.6,0-1-0.4-1-1  s0.4-1,1-1h4c0.6,0,1,0.4,1,1v4C16.3,7.8,15.9,8.3,15.3,8.3z M7.3,16.3h-4c-0.6,0-1-0.4-1-1v-4c0-0.6,0.4-1,1-1s1,0.4,1,1v3h3  c0.6,0,1,0.4,1,1S7.9,16.3,7.3,16.3z M6.6,8L2.3,3.7v2.6c0,0.6-0.4,1-1,1s-1-0.4-1-1v-5c0-0.6,0.4-1,1-1h5c0.6,0,1,0.4,1,1  s-0.4,1-1,1H3.7L8,6.6L6.6,8z"></path>
                                            </svg></span>Extend { this.state.selectedVolume.name }</h2>
                                        </div>
                                        <div className="createVol_content_wrap">
                                            <div className="common_txtBox_row">
                                                <label>Size<span className="moreInfo" style={ { display: "none" } }>&nbsp;-&nbsp;(enter a multiple of 1 GB)</span></label>
                                                <div className="txtBox_wrap">
                                                    <input type="text" name="extendVolume" id="extendVolume" value={ this.state.extendVolume } onChange={ (e) => this.formHandler(e) } autoComplete="off"
                                                        className="txt_box" placeholder="Provide new size" onKeyDown={ (e) => this.onVolKeydown(e, 'extend') } />
                                                    <span className="label_unit">GB</span> </div>
                                                <p className="info_txt">Enter a new size for the volume.The size of your volume may range upto 1 TB (1000 GB).
                                                    For yearly volumes, the size must be greater than 10 GB and for monthly volumes it must be greater than 1 GB.
                                                    This operation is irreversible.</p>
                                                <span className="comm_error_msg">{ this.state.errorMessg }</span>
                                            </div>
                                            {/* <div className="common_txtBox_row">
                                                <label>Total Cost</label>
                                                 <input type="text" name="" value="$ 17.50/mo" className="txt_box totl_cost" placeholder="" disabled="" />
                                            </div> */}
                                            <div className="cta_wrap">
                                                <input type="button" name="" value="Extend" className="common_cta_btn blue" onClick={ () => this.extendVolumeSize("before") } />
                                                <input type="button" name="" value="Cancel" onClick={ () => this.extendCancel() } className="common_cta_btn transparentGrey" />
                                            </div>
                                            <div className="common_txtBox_row"><b>Note:</b> To add a volume greater than 1000 GB, <a href="https://www.idrivecompute.com/support.htm" target="_blank"> Contact support</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="main_slider attachVolume_slider">
                            <div className="slider_bg_shadow"></div>
                            <div className="slider_wrapper">
                                <div className="main_slider_container">
                                    <div className="close_icon" onClick={ () => this.attachCancel() }></div>
                                    <div className="createVol_slide_wrap">
                                        <div className="head_block">
                                            <h2><span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 18.6 18.6" enableBackground="new 0 0 18.6 18.6" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M2.5,16.5C0,14,0.1,9.7,2.9,6.9l3-3l0,0l2-2c2-2,5.5-2.5,7.4-0.6  c1.9,1.9,1.3,5.2-0.8,7.2l-5.3,5.3c-1.3,1.3-2.8,1.2-4,0s-1.3-2.7,0-4l6-6l1.3,1.3l-6,6c-0.6,0.5-0.5,0.8,0,1.3  c0.5,0.5,0.8,0.5,1.3,0l5.3-5.3c1.3-1.3,2-3.4,0.8-4.5C12.8,1.5,10.5,2,9.2,3.3L3.9,8.6c-2,2-1.9,4.7,0,6.6s4.6,2,6.7,0l6-6l1.3,1.3  l-5.7,5.6C9.4,19,5.1,19.1,2.5,16.5z"></path>
                                            </svg></span>Attach { this.state.selectedVolume.name }</h2>
                                        </div>
                                        <div className="createVol_content_wrap">
                                            <p className="comm_error_msg">{ this.state.errorMessg }</p>
                                            <div className="common_txtBox_row">
                                                <p className="info_txt"><strong>Note:</strong> Volumes cannot be attached to Bare metal instances.</p>
                                                <label>Instance </label>
                                                <div className="custom_select_box">
                                                    <select name="instance" value={ this.state.selectedInstanceId } onChange={ (e) => this.formHandler(e) }>
                                                        { this.state.instanceList.length === 0 ? <option value='' default>No instance available</option> : <option value='' style={ { display: "none" } } default>Select an instance to attach the volume</option> }
                                                        { this.state.instanceList.map((instance, j) =>
                                                            <option key={ j } value={ instance.id } >{ instance.name }</option>
                                                        ) }
                                                    </select>
                                                </div>
                                                { this.state.instanceList.length === 0 ? <p className="info_txt" >Create an instance to attach</p> : <p className="info_txt" >Attach the volume to an instance</p> }
                                            </div>
                                            <div className="cta_wrap">
                                                <input type="button" name="" value="Attach" className="common_cta_btn blue" onClick={ () => this.attachVolumetoInstance() } />
                                                <input type="button" name="" value="Cancel" onClick={ () => this.attachCancel() } className="common_cta_btn transparentGrey" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <div className="main_popup detach_settngVolume_popup">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" onClick={ () => this.detachCancel() } data-toggle="tooltip" title="" data-original-title="Close"></span>
                                <div className="popup_header">
                                    <div className="sub_title"> Detach <span className="volName"> { this.state.selectedVolume.name } </span></div>
                                </div>
                                <div className="popup_body">
                                    <p >This will detach the volume from the compute instance it is attached to. Before detaching, make sure that the instance is currently not writing to the volume. It is also advisable to unmount the volume before detaching it from the instance. If the volume is mounted, detaching it could cause your instance to restart.</p>
                                    <p >On detaching the volume from the current instance, you cannot access the volume and the stored data without attaching it to another instance.</p>
                                    <p >Are you sure you want to detach from <b><span className="detach_Vol_name">{ this.getInstanceName(this.state.selectedVolume) }</span></b> ?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button className="btn btn_confirm" onClick={ () => this.detachInstance() }>Detach</button>
                                        <button className="btn btn_cancel" onClick={ () => this.detachCancel() }>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main_popup delete_volume_popup" >
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span onClick={ () => this.deleteCancelClick() } className="close_icon" data-toggle="tooltip" title="" data-original-title="Close"></span>
                                <div className="popup_header">
                                    <div className="sub_title"> Delete</div>
                                </div>
                                <div className="popup_body">
                                    <p >This will permanently delete the volume from your account along with the existing data. The operation is irreversible.</p>
                                    <p >Before deleting, it is recommended to detach and unmount the volume to prevent data irregularities. Also, power off the compute instance and make sure that it is currently not writing to the volume. If the volume is mounted, deleting it could cause your instance to restart.</p>
                                    <p >Are you sure you want to delete the volume <b>{ this.state.selectedVolume.name }</b> ?</p>
                                    <p><strong>Note:</strong> Any charges incurred will not be refunded on deleting the prepaid yearly volume.</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button id="volDelBtn" className="btn btn_confirm" onClick={ () => this.deleteVolumeById() }>Delete</button>
                                        <button className="btn btn_cancel" onClick={ () => this.deleteCancelClick() }>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={ this.state.openAmountPopUp ? "main_popup delete_instanceSetting_popup active" : "main_popup delete_instanceSetting_popup" }>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap">
                                <span className="close_icon" onClick={ () => { this.setState({ openAmountPopUp: false }); $("body").removeClass("popup_no_scroll"); } }></span>
                                <div className="popup_header">
                                    <div className="sub_title">Extend Volume</div>
                                </div>
                                <div className="resize_popup_body">
                                    <div className="popup_body">
                                        <p>You are subscribing to a prepaid yearly plan and your credit card will be charged <b>${ this.state.amount }</b> for the chosen plan. The amount is non-refundable.</p>
                                        <p className="usage-amt">Amount Payable: <span>${ this.state.amount }</span></p>
                                        <p className="imp_warn_note"><strong>Note:</strong> The extend operation is irreversible.</p>
                                        <p>Are you sure you want to extend the size of the volume  <b>{ this.state.delVolName }</b> ?</p>
                                    </div>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button type="button" className="btn btn_confirm" id="setresizeBtn" onClick={ () => this.extendVolumeSize("after") }>Extend</button>
                                        <button type="button" className="btn btn_cancel" onClick={ () => { this.setState({ openAmountPopUp: false }); $("body").removeClass("popup_no_scroll"); } }>Cancel</button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main_slider volSnapshot_slider">
                    <div className="slider_bg_shadow"></div>
                    <div className="slider_wrapper">
                        <div className="main_slider_container">
                            <div className="close_icon" onClick={ () => this.backupCancel() }></div>
                            <div className="createVol_slide_wrap">
                                <div className="head_block">
                                    <h2><span className="icon_img"> <span className="icon" ></span> </span>Create backup for volume</h2>
                                </div>
                                <div className="createVol_content_wrap">
                                    <p className="info_txt">Volume backups are billed per month at <b>$0.10/GB</b>.</p>
                                    <p className="info_txt">While volume backup is in progress, no action can be performed on this volume.</p>
                                    <p style={ { display: this.state.selectedVolume.attachments && this.state.selectedVolume.attachments.length > 0 ? '' : 'none', color: 'red' } } ><b>Warning: </b>Inorder to make a backup consistent, detach the instance first</p>
                                    <div className="common_txtBox_row">
                                        <label>Volume Name</label>
                                        <input type="text" value={ this.state.selectedVolume.name } onChange={ this.formHandler } className="txt_box" disabled />
                                    </div>
                                    <div className="common_txtBox_row">
                                        <label>Backup Name</label>
                                        <input type="text" id="backupname1" name="backupName" value={ this.state.backupName } onChange={ this.formHandler } className="txt_box" onKeyDown={ (e) => this.onVolKeydown(e, 'backup') } autoComplete="chrome-off" maxLength="20" />
                                        <p className="comm_error_msg"> { this.state.errorMessg } </p>
                                    </div>
                                    {/* <div className="common_txtBox_row">
                <label>Total Cost</label>
                <input type="text" name="" value="$ 17.50/mo" className="txt_box totl_cost" placeholder="" disabled=""/>
              </div> */}
                                    <div className="cta_wrap">
                                        <input type="button" name="" value="Create Backup" className="common_cta_btn blue" onClick={ () => this.createBackup() } />
                                        <input type="button" name="" value="Cancel" onClick={ () => this.backupCancel() } className="common_cta_btn transparentGrey" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CommonMessage message={ this.state.message } isUserSubscribed={ this.state.isUserSubscribed } msgType={ this.state.messgType } handler={ () => this.setState({ message: '' }) } />
            </body>
        );
    }
}
function loadcss() {
    const link = document.createElement("link");
    link.href = "https://www.idrivecompute.com/webapp/css/volumes.css";
    link.rel = "stylesheet";
    link.type = "text/css";
    document.head.appendChild(link);
}
function formatDate(d) {
    return d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear() + ' ' + d.toLocaleString([], {
        hour: '2-digit',
        minute: '2-digit'
    });
}

export default VolumesMain;